// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.reusable-paginator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  color: #53647a;
  font-size: 12px;
}
.reusable-paginator__indicator {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
}
.reusable-paginator__indicator span {
  color: #8491a3;
  margin-inline-start: 4px;
}
.reusable-paginator__controls {
  display: flex;
  align-items: center;
  gap: 18px;
}
.reusable-paginator__buttons {
  display: flex;
  align-items: center;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  overflow: hidden;
}
.reusable-paginator__buttons button {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: 0;
  background: white;
  color: #53647a;
  font: inherit;
  cursor: pointer;
}
.reusable-paginator__buttons button:not(:last-child) {
  border-inline-end: 1px solid #dce5ef;
}
.reusable-paginator__buttons button:hover:not(:disabled), .reusable-paginator__buttons button.active {
  background: color-mix(in srgb, var(--primary-color) 9%, white);
  color: var(--primary-color);
}
.reusable-paginator__buttons button:disabled {
  color: #bec8d5;
  cursor: default;
}
.reusable-paginator__buttons button span {
  font-size: 18px;
}

.page-size {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.page-size .page-size-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 58px;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  height: 32px;
  background: white;
  color: #253750;
  padding: 0 8px;
  font: inherit;
  cursor: pointer;
}
.page-size .page-size-trigger span {
  font-size: 17px;
}
.page-size .page-size-trigger:hover {
  background: color-mix(in srgb, var(--primary-color) 5%, white);
}

.page-size-option {
  min-height: 34px;
  --mat-menu-item-label-text-size: 12px;
}
.page-size-option.selected {
  color: var(--primary-color);
  background: color-mix(in srgb, var(--primary-color) 9%, white);
}
.page-size-option .selected-icon {
  font-size: 16px;
  vertical-align: middle;
  margin-inline-start: 20px;
}

button:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);
  outline-offset: -2px;
}

@media (max-width: 650px) {
  .reusable-paginator {
    flex-wrap: wrap;
    padding: 12px;
  }
  .reusable-paginator__controls {
    flex-wrap: wrap;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/reusable-paginator/reusable-paginator.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AACJ;AACI;EACE,cAAA;EACA,wBAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AAFN;AAIM;EACE,oCAAA;AAFR;AAKM;EAEE,8DAAA;EACA,2BAAA;AAJR;AAOM;EACE,cAAA;EACA,eAAA;AALR;AAQM;EACE,eAAA;AANR;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AATF;AAWE;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AATJ;AAWI;EACE,eAAA;AATN;AAYI;EACE,8DAAA;AAVN;;AAeA;EACE,gBAAA;EACA,qCAAA;AAZF;AAcE;EACE,2BAAA;EACA,8DAAA;AAZJ;AAeE;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;AAbJ;;AAiBA;EACE,sEAAA;EACA,oBAAA;AAdF;;AAiBA;EACE;IACE,eAAA;IACA,aAAA;EAdF;EAgBE;IACE,eAAA;IACA,SAAA;EAdJ;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.reusable-paginator {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 18px;\n  color: #53647a;\n  font-size: 12px;\n\n  &__indicator {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 500;\n\n    span {\n      color: #8491a3;\n      margin-inline-start: 4px;\n    }\n  }\n\n  &__controls {\n    display: flex;\n    align-items: center;\n    gap: 18px;\n  }\n\n  &__buttons {\n    display: flex;\n    align-items: center;\n    border: 1px solid #dce5ef;\n    border-radius: 8px;\n    overflow: hidden;\n\n    button {\n      display: grid;\n      place-items: center;\n      width: 32px;\n      height: 32px;\n      border: 0;\n      background: white;\n      color: #53647a;\n      font: inherit;\n      cursor: pointer;\n\n      &:not(:last-child) {\n        border-inline-end: 1px solid #dce5ef;\n      }\n\n      &:hover:not(:disabled),\n      &.active {\n        background: color-mix(in srgb, var(--primary-color) 9%, white);\n        color: var(--primary-color);\n      }\n\n      &:disabled {\n        color: #bec8d5;\n        cursor: default;\n      }\n\n      span {\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n.page-size {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n\n  .page-size-trigger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    min-width: 58px;\n    border: 1px solid #dce5ef;\n    border-radius: 7px;\n    height: 32px;\n    background: white;\n    color: #253750;\n    padding: 0 8px;\n    font: inherit;\n    cursor: pointer;\n\n    span {\n      font-size: 17px;\n    }\n\n    &:hover {\n      background: color-mix(in srgb, var(--primary-color) 5%, white);\n    }\n  }\n}\n\n.page-size-option {\n  min-height: 34px;\n  --mat-menu-item-label-text-size: 12px;\n\n  &.selected {\n    color: var(--primary-color);\n    background: color-mix(in srgb, var(--primary-color) 9%, white);\n  }\n\n  .selected-icon {\n    font-size: 16px;\n    vertical-align: middle;\n    margin-inline-start: 20px;\n  }\n}\n\nbutton:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);\n  outline-offset: -2px;\n}\n\n@media (max-width: 650px) {\n  .reusable-paginator {\n    flex-wrap: wrap;\n    padding: 12px;\n\n    &__controls {\n      flex-wrap: wrap;\n      gap: 12px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
